/* oxlint-disable */
import { BonusStatusCasino } from '@/enums/core';

import { freeSpinGamesIncludeGame } from '@/utils/freeSpinGameMatch';

export interface FreeSpinRowLike {
  games?: unknown;
  status?: number | string | null;
  expiration_date?: string | Date | null;
}

/**
 * True if the user has at least one casino free spin row that is applied, not expired,
 * and matches the game identifier (same matching rules as freeSpinGamesIncludeGame).
 */
export function hasValidFreeSpinForGame(
  freeSpins: FreeSpinRowLike[] | undefined | null,
  gameIdentifier: string,
): boolean {
  try {
    const rows = Array.isArray(freeSpins) ? freeSpins : [];
    const now = Date.now();

    return rows.some((spin) => {
      try {
        if (Number(spin.status) !== BonusStatusCasino.APPLIED) {
          return false;
        }

        if (spin.expiration_date == null) {
          return false;
        }

        const expMs = new Date(spin.expiration_date).getTime();

        if (!Number.isFinite(expMs) || expMs <= now) {
          return false;
        }

        return freeSpinGamesIncludeGame(spin.games, gameIdentifier);
      } catch (innerError) {
        console.warn('hasValidFreeSpinForGame row error:', innerError);
        return false;
      }
    });
  } catch (error) {
    console.warn('hasValidFreeSpinForGame error:', error);
    return false;
  }
}